<template>
    <div id="app">
        <headerbar v-if="routePage && !isLoginPage" />
        <side-menu v-if="routePage && !isLoginPage" />
        <menu-ad v-if="routePage === 'home'" />
        <div class="contaniner" :class="isLoginPage ? 'full' : ''">
            <router-view @authFail="authFail"/>
        </div>
        <el-dialog
            class="mine failDialog"
            title="操作失败"
            width="600px"
            :visible.sync="authFailShow">
            <div class="normal">对不起，您没有该功能操作权限！</div>
            <span slot="footer">
                <el-button
                    type="primary"
                    class="closeBtn"
                    @click="authFailShow = false">知道了</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { Dialog, Button } from 'element-ui';
import headerbar from './components/HeaderBar';
import sideMenu from './components/SideMenu';
import menuAd from './components/MenuAd';

Vue.use(Dialog);
Vue.use(Button);

export default {
    name: 'App',
    data() {
        return {
            authFailShow: false,
        };
    },
    components: {
        headerbar,
        sideMenu,
        menuAd
    },
    computed: {
        ...mapState({
            isLoginPage: state => state.route.name === 'login' || state.route.name === 'printOrder' || state.route.name === 'printStoreDetail' || state.route.name === 'printExam',
            routePage  : state => state.route.name,
        })
    },
    created() {
        this.initSideMenu();
    },
    methods: {
        ...mapActions([
            'initSideMenu'
        ]),
        authFail() {
            this.authFailShow = true;
        }
    }
};
</script>
<style lang="stylus" src="@/assets/styles/app.styl"></style>



// WEBPACK FOOTER //
// src/App.vue